export function customMask(
  value: string,
  mask: string,
  token: RegExp = /\d/
): string {
  const digits = value.replace(/\D/g, '');
  let digitIndex = 0;
  let result = '';

  for (const char of mask) {
    if (token.test(char)) {
      if (digitIndex >= digits.length) break;

      result += digits[digitIndex];
      digitIndex++;
    } else {
      if (digitIndex < digits.length) {
        result += char;
      }
    }
  }

  return result;
}
